<template>
  <nav id="frontmenu" aria-label="網站主導航" class="pt-4 font menu no-print">
    <div class="container">
      <!-- 菜單項目 -->
      <div class="row">
        <!-- Web -->
        <!-- <v-menu
          v-if="LoginCheck === 'false'"
          menu-link="/home/registration"
          menu-icon="id-card"
          menu-text="註冊(Registration)"
        /> -->
        <v-menu
          v-if="LoginCheck === 'false'"
          menu-link="/home/identity"
          menu-icon="sign-in-alt"
          menu-text="登入(Login)"
        />
        <v-menu
          v-if="LoginCheck === 'true'"
          menu-mr="true"
          menu-web="true"
          menu-link="/feeorder/personal"
          menu-icon="cart-plus"
          menu-iconcss="true"
          menu-fontcss="true"
          menu-text="繳款項目"
        >
          <v-font slot="menu-eg" font-css="spanfs" font-text="Fee" />
        </v-menu>
        <v-menu
          v-if="LoginCheck === 'true'"
          menu-mr="true"
          menu-web="true"
          menu-link="/home/receipt"
          menu-icon="search-dollar"
          menu-iconcss="true"
          menu-fontcss="true"
          menu-text="已繳款查詢"
        >
          <v-font slot="menu-eg" font-css="spanfs" font-text="Paid Inquery" />
        </v-menu>
        <v-menu
          v-if="LoginCheck === 'true'"
          menu-mr="true"
          menu-web="true"
          menu-link="/home/account/user"
          menu-icon="user-cog"
          menu-iconcss="true"
          menu-fontcss="true"
          menu-text="帳號更新"
        >
          <v-font
            slot="menu-eg"
            font-css="spanfs"
            font-text="Account Management"
          />
        </v-menu>
        <v-menu
          v-if="LoginCheck === 'true'"
          menu-mr="true"
          menu-web="true"
          menu-link="#"
          menu-icon="sign-out-alt"
          menu-iconcss="true"
          menu-fontcss="true"
          menu-text="登出"
          @click.native="logout"
        >
          <v-font slot="menu-eg" font-css="spanfs" font-text="Logout" />
        </v-menu>
        <!-- Mobile -->
        <v-button
          v-if="LoginCheck === 'true'"
          class="ml-4 mr-4 dropdown-toggle mobile"
          btn-text="選單"
          btn-size="lg"
          btn-block="true"
          btn-outline="secondary"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          aria-controls="mobile-menu"
        >
          <v-font slot="eg" font-css="spanfs" font-text="Menu" />
        </v-button>
        <div
          v-if="LoginCheck === 'true'"
          class="dropdown-menu"
          id="mobile-menu"
        >
          <router-link class="dropdown-item" to="/feeorder/personal">
            繳款項目
            <v-font font-css="spanfs" font-text="Fee" />
          </router-link>
          <router-link class="dropdown-item" to="/home/receipt">
            已繳款查詢
            <v-font font-css="spanfs" font-text="Paid Inquery" />
          </router-link>
          <router-link class="dropdown-item" to="/home/account/user">
            帳號更新
            <v-font font-css="spanfs" font-text="Account Management" />
          </router-link>
          <div class="dropdown-divider" />
          <v-button
            btn-type="link"
            btn-text="登出"
            class="dropdown-item"
            @click.native="logout"
          >
            <v-font slot="eg" font-css="spanfs" font-text="Logout" />
          </v-button>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import vMenu from '@/components/Features/FrontMenu'
import $ from 'jquery'
export default {
  components: {
    vMenu
  },
  data () {
    return {
      LoginCheck: localStorage.getItem('M_Menu') === 'true' ? 'true' : 'false'
    }
  },
  created () {
    const vm = this
    // 接收登入動作
    vm.$bus.$on('LoginCheckUser', data => {
      vm.LoginCheckUser(data)
    })
    vm.$bus.$on('LogOutCheckUser', data => {
      vm.LoginOutUser(data)
    })
  },
  methods: {
    LoginCheckUser (data) {
      // 判斷登入變換菜單項目
      this.LoginCheck = 'true'
    },
    LoginOutUser (data) {
      // 判斷登出變換菜單項目
      this.logout()
    },
    logout () {
      // 登出刪除Token
      var checked = localStorage.getItem('M_checked')
      var KeepUserId = localStorage.getItem('M_KeepUserId')
      var Version = localStorage.getItem('Version')
      // localStorage
      localStorage.clear()
      localStorage.setItem('M_checked', checked)
      localStorage.setItem('Version', Version)
      if (KeepUserId !== null) {
        localStorage.setItem('M_KeepUserId', KeepUserId)
      }
      // 判斷登出，變換菜單項目、帳號資訊
      const vm = this
      vm.LoginCheck = 'false'
      vm.$bus.$emit('LogOutUser', 'null')
      vm.$bus.$emit('messsage:push', '已登出', 'primary')
      $('#LogOut').modal('show')
      vm.$router.push('/home/news')
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/menu.scss";
</style>
